define('Store.Selector.View', [
	'Backbone',
	'jQuery',
	'Profile.Model',
	'store_selector.tpl',
	'Store.Cookie',
	'Store.Selector.Collection',
	'Store.Selector.Results',
	'Utilities.CookieJar',
	'Utils'
], function StoreSelectorView(
	Backbone,
	jQuery,
	ProfileModel,
	storeSelectorTpl,
	StoreCookie,
	StoreSelectorCollection,
	StoreSelectorView,
	CookieJar,
	Utils
) {
	'use strict';

	return Backbone.View.extend({
		template: storeSelectorTpl,
		events: {
			'submit form': 'searchStores',
			'click [data-action="select-store"]': 'changeStore',
			'keydown .store-finder-content': 'keyPressDropdown'
		},
		childViews: {
			'Store.Selector.Results': function storeSelectorResultsView() {
				return new StoreSelectorView({
					collection: this.collection,
					profile: ProfileModel.getInstance()
				});
			}
		},
		initialize: function initialize(options) {
			this.application = options.application;
			this.collection = new StoreSelectorCollection();
			this.collection.fetch();
		},
		keyPressDropdown: function keyPressDropdown(e) {
			if (e.keyCode === 27) {
				this.application.getLayout().$('#store-finder-container').dropdown('toggle');
			}
		},
		searchStores: function switchStore(e) {
			var $input = this.$('[name="zipcode"]');
			var value = $input.val();
			e.preventDefault();

			if (!value || value.length !== 5) {
				this.$('.zip-error').text(Utils.translate('Invalid ZipCode'));
				return;
			}

			this.$('.zip-error').text('');
			this.collection.fetch({
				data: {
					zipcode: $input.val()
				}
			});
		},
		changeStore: function changeStore(e) {
			var $btn = jQuery(e.target);
			var id = $btn.data('id');
			var Model = Backbone.Model.extend({
				url: Utils.getAbsoluteUrl(getExtensionAssetsPath('services/Store.Profile.Service.ss'))
			});
			var model = new Model({ internalid: id });

			model.save().done(function onChange() {
				StoreCookie.set(model.get('internalid'));
				CookieJar.setItem('needsCartCheck', 'true');
				window.location.reload();
			});
		},
		getContext: function getContext() {
			var store = ProfileModel.getInstance().get('store');
			return {
				storeName: store.get('name')
			};
		}
	});
});
